import request from '@/http/http'
const PREFIX = '/api/deer/companystores';
//获取分销商门店列表
export function getCompanyStores(query) {
  return request({
    url: PREFIX,
    params: query
  })
}

//删除分销商门店
export function deleteCompanyStore(id) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id
  })
}

//批量删除分销商门店
export function deleteCompanyStores(ids) {
  return request({
    method: "delete",
    url: PREFIX + '?ids=' + ids
  })
}

//创建分销商门店
export function addCompanyStore(formData) {
  return request({
    method: "post",
    url: PREFIX,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//更新分销商门店
export function updateCompanyStore(id, formData) {
  return request({
    method: "put",
    url: PREFIX + '/' + id,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//通过分销商门店标识获取详细信息
export function getCompanyStoreDetail(id) {
  return request({
    method: "get",
    url: PREFIX + '/' + id
  })
}

// 更新分销商门店状态
export function updateStatus(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-status',
    data
  })
}

// 更新分销商门店-分销商
export function changeCompany(id,companyId) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/change-company/' + companyId
  })
}

// 更新分销商门店-负责人
export function changeUser(id,userId) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/change-user/' + userId
  })
}

// 批量更新分销商门店-负责人
export function bindingStoreUser(data) {
  return request({
    method: "post",
    url: PREFIX + '/binding-for-user',
    data
  })
}

// 大事记-------------------------------------------------------------
// 根据条件获取分销商门店大事件记录
export function eventRecords(params) {
  return request({
    method: "get",
    url: PREFIX + '/event-records',
    params
  })
}
// 添加分销商门店大事件记录
export function addEventRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/add-event-record',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 更新分销商门店大事件记录
export function updateEventRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-event-record',
    data
  })
}
//上传分销商门店大事件记录资料附件
export function uploadEventRecordMaterials(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/upload-event-record-materials',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 删除大事件记录
export function deleteEventRecord(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-event-record',
    params
  })
}
// 删除大事件记录附件
export function deleteEventRecordMaterials(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-event-record-materials',
    params
  })
}
// 下载大事件记录附件
export function downloadEventRecordMaterial(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/download-event-record-material',
    params,
    responseType: 'blob'
  })
}


// 巡店记录-------------------------------------------------------------
// 根据条件获取分销商门店巡店记录
export function followRecords(params) {
  return request({
    method: "get",
    url: PREFIX + '/follow-records',
    params
  })
}
// 添加分销商门店巡店记录
export function addFollowRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/add-follow-record',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 更新分销商门店巡店记录
export function updateFollowRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-follow-record',
    data
  })
}
//上传分销商门店巡店记录资料附件
export function uploadFollowRecordMaterials(id,data) {
  return request({
    method: "post",
    url: PREFIX + '/' + id + '/upload-follow-record-materials',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 删除巡店记录
export function deleteFollowRecord(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-follow-record',
    params
  })
}
// 删除巡店记录附件
export function deleteFollowRecordMaterials(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-follow-record-materials',
    params
  })
}
// 下载巡店记录附件
export function downloadFollowRecordMaterial(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/download-follow-record-material',
    params,
    responseType: 'blob'
  })
}



//电子档案--------------------------------------------------------------
//根据分销商门店标识获取分销商门店电子档案信息
export function getMaterials(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/materials',
    params
  })
}
//上传电子档案
export function uploadMaterials(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/upload-materials',
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  })
}
//下载电子档案
export function downloadMaterials(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/download-materials',
    params,
    responseType: 'blob'
  })
}
//删除电子档案
export function deleteMaterials(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-materials',
    params
  })
}

//导出
export function exportCompanyStoresExport(query) {
  return request({
      url: PREFIX + '/export',
      responseType: 'blob',
      params:query
  })
}